import { render } from "./Nav.vue?vue&type=template&id=5c1e9ff9&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./nav.scss?vue&type=style&index=0&id=5c1e9ff9&lang=scss&scoped=true"

import exportComponent from "/Users/mac/lavide-pro2/lavideo-pages/noka/lwInno.com /node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1e9ff9"]])

export default __exports__